import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const TeaserReportConfirm = ({
  open,
  onClose,
  onConfirm,
  title = "Are you sure?",
  message = "This action cannot be undone.",
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelText}</Button>
        <Button onClick={onConfirm} color="error" autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Example usage in a parent component
const ParentComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [actionToConfirm, setActionToConfirm] = useState(null);

  const handleOpenModal = (action) => {
    setActionToConfirm(action);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setActionToConfirm(null);
  };

  const handleConfirm = () => {
    console.log("Confirmed action:", actionToConfirm);
    // Perform the action here
    handleCloseModal();
  };

  return (
    <div>
      <Button
        variant="contained"
        color="error"
        onClick={() => handleOpenModal("delete")}
      >
        Delete Item
      </Button>

      <Button
        variant="outlined"
        onClick={() => handleOpenModal("update")}
        sx={{ ml: 2 }}
      >
        Update Settings
      </Button>

      <TeaserReportConfirm
        open={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirm}
        title={
          actionToConfirm === "delete" ? "Confirm Deletion" : "Confirm Update"
        }
        message={
          actionToConfirm === "delete"
            ? "Are you sure you want to delete this item? This cannot be undone."
            : "Are you sure you want to update these settings?"
        }
        confirmText={actionToConfirm === "delete" ? "Delete" : "Update"}
      />
    </div>
  );
};

export default TeaserReportConfirm;
